(function () {
  var deadline = new Date("2026-07-10T17:00:00-05:00").getTime();

  function pad(value) {
    return String(value).padStart(2, "0");
  }

  function updateCountdown() {
    var timers = document.querySelectorAll("[data-yb-countdown]");
    if (!timers.length) return;
    var diff = Math.max(0, deadline - Date.now());
    var values = {
      days: Math.floor(diff / 86400000),
      hours: Math.floor((diff % 86400000) / 3600000),
      minutes: Math.floor((diff % 3600000) / 60000),
      seconds: Math.floor((diff % 60000) / 1000)
    };
    timers.forEach(function (timer) {
      Object.keys(values).forEach(function (key) {
        var node = timer.querySelector("[data-yb-" + key + "]");
        if (node) node.textContent = key === "days" ? values[key] : pad(values[key]);
      });
    });
  }

  function setupMobileMenu() {
    var toggle = document.querySelector("[data-yb-menu-toggle]");
    var drawer = document.querySelector("[data-yb-mobile-drawer]");
    if (!toggle || !drawer) return;
    toggle.addEventListener("click", function () {
      var isOpen = toggle.getAttribute("aria-expanded") === "true";
      toggle.setAttribute("aria-expanded", String(!isOpen));
      drawer.setAttribute("aria-hidden", String(isOpen));
    });
  }

  function setupFaqs() {
    document.querySelectorAll("[data-yb-faq]").forEach(function (faq) {
      faq.addEventListener("click", function (event) {
        var button = event.target.closest(".yb-faq-question");
        if (!button) return;
        var item = button.closest(".yb-faq-item");
        var isOpen = item.classList.toggle("is-open");
        button.setAttribute("aria-expanded", String(isOpen));
        var icon = button.querySelector(".yb-faq-icon");
        if (icon) icon.textContent = isOpen ? "-" : "+";
      });
    });
  }

  function setupProductVariants() {
    var form = document.querySelector("[data-yb-product-form], .yb-product-form");
    if (!form) return;
    var hidden = form.querySelector('input[name="id"]');
    var cards = Array.prototype.slice.call(document.querySelectorAll("[data-yb-variant-card]"));
    if (!hidden || !cards.length) return;

    function select(card) {
      cards.forEach(function (item) { item.classList.remove("is-selected"); });
      card.classList.add("is-selected");
      var input = card.querySelector('input[type="radio"]');
      if (input) {
        input.checked = true;
        hidden.value = input.value;
      }
      form.setAttribute("data-yb-bonus-variants", card.getAttribute("data-yb-bonus-variants") || "");
    }

    cards.forEach(function (card) {
      card.addEventListener("click", function () { select(card); });
      card.addEventListener("keydown", function (event) {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          select(card);
        }
      });
    });
    var selected = document.querySelector("[data-yb-variant-card].is-selected") || cards[0];
    if (selected) select(selected);
  }

  function setupOfferQuantityCards() {
    var cards = Array.prototype.slice.call(document.querySelectorAll("[data-yb-qty-card]"));
    if (!cards.length) return;

    function select(card) {
      var scrollX = window.scrollX;
      var scrollY = window.scrollY;
      cards.forEach(function (item) { item.classList.remove("is-selected"); });
      card.classList.add("is-selected");
      var input = card.querySelector('input[type="radio"]');
      if (input) input.checked = true;
      window.requestAnimationFrame(function () {
        window.scrollTo(scrollX, scrollY);
      });
    }

    cards.forEach(function (card) {
      card.addEventListener("click", function (event) {
        if (event.target.tagName !== "INPUT") event.preventDefault();
        select(card);
      });
    });
  }

  function parseVariantIds(value) {
    return String(value || "")
      .split(",")
      .map(function (item) { return item.trim(); })
      .filter(function (item) { return /^\d+$/.test(item); });
  }

  function submitCartItems(form, plannerId, bonusIds, prefix) {
    if (!window.fetch || !/^\d+$/.test(plannerId) || !bonusIds.length) return false;
    var button = form.querySelector('button[type="submit"]');
    if (button) {
      button.disabled = true;
      button.setAttribute("aria-busy", "true");
    }
    form.setAttribute(prefix + "-submitting", "true");
    var items = bonusIds.slice().reverse().map(function (id) {
      return { id: Number(id), quantity: 1 };
    }).concat([{ id: Number(plannerId), quantity: 1 }]);

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({ items: items })
    }).then(function (response) {
      if (!response.ok) throw new Error("Cart add failed");
      var redirect = form.querySelector('input[name="return_to"]');
      window.location.href = redirect && redirect.value ? redirect.value : "/cart";
    }).catch(function () {
      form.removeAttribute(prefix + "-submitting");
      if (button) {
        button.disabled = false;
        button.removeAttribute("aria-busy");
      }
      HTMLFormElement.prototype.submit.call(form);
    });
    return true;
  }

  function setupBonusCartForms() {
    document.querySelectorAll(".yb-landing-form").forEach(function (form) {
      form.addEventListener("submit", function (event) {
        if (form.getAttribute("data-yb-landing-submitting") === "true") return;
        var selectedInput = form.querySelector('input[name="id"]:checked') || form.querySelector('input[name="id"]');
        var selectedCard = selectedInput ? selectedInput.closest("[data-yb-qty-card]") : null;
        var bonusIds = selectedCard ? parseVariantIds(selectedCard.getAttribute("data-yb-bonus-variants")) : [];
        if (!submitCartItems(form, selectedInput ? selectedInput.value : "", bonusIds, "data-yb-landing")) return;
        event.preventDefault();
      });
    });

    document.querySelectorAll(".yb-product-form").forEach(function (form) {
      form.addEventListener("submit", function (event) {
        if (form.getAttribute("data-yb-product-submitting") === "true") return;
        var hidden = form.querySelector('input[name="id"]');
        var selectedCard = document.querySelector("[data-yb-variant-card].is-selected");
        var bonusSource = selectedCard ? selectedCard.getAttribute("data-yb-bonus-variants") : form.getAttribute("data-yb-bonus-variants");
        var bonusIds = parseVariantIds(bonusSource);
        if (!submitCartItems(form, hidden ? hidden.value : "", bonusIds, "data-yb-product")) return;
        event.preventDefault();
      });
    });
  }

  function setupRevealAnimations() {
    var items = Array.prototype.slice.call(document.querySelectorAll(".yb-reveal"));
    if (!items.length) return;
    if (!("IntersectionObserver" in window)) {
      items.forEach(function (item) { item.classList.add("is-visible"); });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add("is-visible");
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.12 });
    items.forEach(function (item) { observer.observe(item); });
  }

  function setupStickyCta() {
    var sticky = document.querySelector("[data-yb-sticky-cta]");
    var triggers = document.querySelectorAll("[data-yb-sticky-trigger]");
    var trigger = triggers[triggers.length - 1];
    var stop = document.querySelector("[data-yb-sticky-stop]");
    if (!sticky || !trigger) return;

    function update() {
      var triggerBottom = trigger.getBoundingClientRect().bottom;
      var stopVisible = false;
      if (stop) {
        var stopRect = stop.getBoundingClientRect();
        stopVisible = stopRect.top < window.innerHeight && stopRect.bottom > 0;
      }
      sticky.classList.toggle("is-visible", triggerBottom < 0 && !stopVisible && window.innerWidth < 760);
    }

    update();
    window.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
  }

  updateCountdown();
  setInterval(updateCountdown, 1000);
  setupMobileMenu();
  setupFaqs();
  setupProductVariants();
  setupOfferQuantityCards();
  setupBonusCartForms();
  setupRevealAnimations();
  setupStickyCta();
})();
